import { atom } from 'jotai';

export const userInfoAtom = atom(null);
export const userRole = atom(null);
